<template>
  <div>
    <vue-signature-pad ref="signaturePad" style="border: 1px solid #ccc;" :options="{ onEnd }" />
    <input type="hidden" name="signature" :value="signature">

    <div class="mt-2">
      <button type="button" class="btn btn-sm btn-outline-primary" @click="clear">
        Opnieuw
      </button>
    </div>
  </div>
</template>

<script>
import { VueSignaturePad } from "vue-signature-pad";

export default {
  components: {
    VueSignaturePad
  },

  data() {
    return {
      signature: ''
    }
  },

  methods: {
    clear() {
      this.$refs.signaturePad.clearSignature();
    },

    onEnd() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      if (! isEmpty) {
        this.signature = data;
      }
    }
  }
}
</script>
